module.exports = __webpack_public_path__ + "img/logo.ac1fc6fc.png";